import React from 'react';


function WelcomeFlagShip() {
  return (
    <div className="text-container">
      <div className="welcome-body-wrapper">
        <div className="welcome-paragraph-wrapper">
          <h1>Book your Virtual Appointment with an AMSALE Stylist</h1>
          <p>
            Schedule a personalized virtual appointment with a stylist from our AMSALE Flagship in SoHo.
            Our dedicated stylists will guide you and/or your Bridal Party to discover the perfect AMSALE dress, no
            matter
            where you and your party are.
          </p>
        </div>
        <div className="welcome-paragraph-wrapper">
          <p>
            Please fill out the request form, and our styling team will be in touch to schedule your one-on-one
            30-minute
            video call.
          </p>
        </div>
        <div className="welcome-paragraph-wrapper">
          <strong>
            <h2>
              Why is a virtual appointment perfect for you?
            </h2>
          </strong>
        </div>
        <div className="welcome-paragraph-wrapper">
          <p>
            <h3>
              Personalized Style Guidance
            </h3>
            Meet with a dedicated stylist to determine the best color, fabric, and style for your special
            occasion.
          </p>
        </div>
        <div className="welcome-paragraph-wrapper">
          <p>
            <h3>
              For Brides and Bridal Party Members
            </h3>
            If you and/or your bridal party are unable to come to our NYC Flagship or are in different locations, our
            virtual appointments bring you together with ease.
          </p>
        </div>
        <div className="welcome-paragraph-wrapper">
          <p>
            <h3>
              Streamlined Ordering Process
            </h3>
            Do you already know what dress (color, fabric, and style) you’d like? You and your stylist can discuss
            measurements
            and place an order.
          </p>
        </div>
      </div>
    </div>
  );
}

export default WelcomeFlagShip;
